var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"x-small chips pl-2 pr-2",attrs:{"small":"","close":"","color":_vm.chipsColor,"dark":_vm.chipsColor === 'black'},on:{"click:close":function($event){return _vm.onClose(_vm.name)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }